import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getProfileFromBooking } from '../../../core/util/account';
import { setIsAddressValidated, setValidatedAddress } from '../../../ducks/paperwork';
import { useSolvSelector } from '../../../reducers';
import { usePaperworkContextBookingId } from '../../../routes/paperwork/PaperworkBookingIdContext';

export const useInitializeAddressValidation = () => {
  const dispatch = useDispatch();
  const accountSummary = useSolvSelector((state) => state.account.summary);
  const bookingId = usePaperworkContextBookingId();
  const booking = useSolvSelector((state) => state.pastBookings[bookingId]);
  const userProfile = getProfileFromBooking(accountSummary, booking);
  const paperwork = useSolvSelector((state) => state.paperwork);
  useEffect(() => {
    /**
     * Only want to set this up once, when userProfile is first loaded and paperwork.isAddressValidated is still undefined.
     * Changing paperwork.isAddressValidated and paperwork.validatedAddress will otherwise occur in PatientSectionForm and
     * could be different than what is on the current userProfile
     */
    if (
      !isEmpty(userProfile) &&
      userProfile.is_address_validated &&
      paperwork.isAddressValidated === undefined
    ) {
      dispatch(setIsAddressValidated(true));
      dispatch(
        setValidatedAddress({
          address1: userProfile.address_street,
          address2: userProfile.address_street_secondary,
          city: userProfile.address_city,
          state: userProfile.address_state,
          zip: userProfile.address_zip,
        })
      );
    }
  }, [userProfile, paperwork.isAddressValidated, dispatch]);
};
